import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CodepenOutlinedSvg from "@ant-design/icons-svg/es/asn/CodepenOutlined";
import AntdIcon from "../components/AntdIcon";
var CodepenOutlined = function CodepenOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CodepenOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CodepenOutlined.displayName = 'CodepenOutlined';
}
export default /*#__PURE__*/React.forwardRef(CodepenOutlined);